import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { SaveSuccess } from "assets";
import { BaseButton } from "shared/atoms/BaseButton";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";

export const MarkTreatmentReadyConfirmation = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();

  return (
    <MUIUnifiedModal open onClose={onClose} showCloseButton={false} width="450px">
      <Stack alignItems="center" spacing={2} p={3}>
        <Checkmark />
        <Stack spacing={1} textAlign="center">
          <Typography variant="h3">{t("usercourse.activepopup.header")}</Typography>
          <Typography variant="body1">{t("usercourse.activepopup.body")}</Typography>
        </Stack>
        <BaseButton onClick={() => onClose()} text={t("buttons.close")} />
      </Stack>
    </MUIUnifiedModal>
  );
};

const Checkmark = styled(SaveSuccess)`
  width: 32px;
  height: 32px;
`;
